import { gql } from '@apollo/client';

export const GET_AVAILABLE_CAMPAIGN_TEMPLATES = gql`
    query GetAvailableCampaignTemplates {
        getAvailableCampaignTemplates {
            id
            name
            description
            requiredVariables
            optionalVariables
        }
    }
`;
